import { render, staticRenderFns } from "./ProductsRanking.vue?vue&type=template&id=5cc3a3a6&scoped=true&"
import script from "./ProductsRanking.vue?vue&type=script&lang=js&"
export * from "./ProductsRanking.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRanking.vue?vue&type=style&index=0&id=5cc3a3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc3a3a6",
  null
  
)

export default component.exports